<app-header headerText="Inscripción Caja de Ahorro Permanente" [small]="true"></app-header>

<div class="row blocked">

  <div class="col-md-4">

    <mat-form-field>
      <input matInput placeholder="ID HR:" [value]="currentEmployee.workInformation.employeeNumber" type="text">
    </mat-form-field>

  </div>

</div>

<div class="row blocked">

  <div class="col-md-4">

    <mat-form-field>
      <input matInput placeholder="Nombre:" [value]="currentEmployee.firstName" type="text">
    </mat-form-field>

  </div>

  <div class="col-md-4">

    <mat-form-field>
      <input matInput placeholder="Apellido Paterno:" [value]="currentEmployee.firstLastName" type="text">
    </mat-form-field>

  </div>

  <div class="col-md-4">

    <mat-form-field>
      <input matInput placeholder="Apellido Materno:" [value]="currentEmployee.secondLastName" type="text">
    </mat-form-field>

  </div>

</div>

<div class="row mb-5 blocked">

  <div class="col-md-4">

    <mat-form-field>
      <input matInput placeholder="Centro de Trabajo:"
        [value]="currentEmployee.workInformation.workCenter.workCenterName" type="text">
    </mat-form-field>

  </div>

  <div class="col-md-4">
    <mat-form-field>
      <input matInput placeholder="Departamento:" [value]="currentEmployee.workInformation.department.departmentName"
        type="text">
    </mat-form-field>
  </div>

  <div class="col-md-4">
    <mat-form-field>
      <input matInput placeholder="Centro de Costo:"
        [value]="currentEmployee.workInformation.costCenter.costCenterName" type="text">
    </mat-form-field>
  </div>

</div>

<app-header headerText="Datos del Ciclo" [small]="true"></app-header>

<div class="row blocked">

  <div class="col-md-4">
    <mat-form-field>
      <input matInput placeholder="Inicio:"
        [value]="currentScheduleDate ? (currentScheduleDate.startDate | date: 'mediumDate') : ''" type="text">
    </mat-form-field>
  </div>

  <div class="col-md-4">
    <mat-form-field>
      <input matInput placeholder="Fin:"
        [value]="currentScheduleDate && currentScheduleDate.endDate ? (currentScheduleDate.endDate | date: 'mediumDate') : 'Indefinido'"
        type="text">
    </mat-form-field>
  </div>

  <div class="col-md-4">
    <mat-form-field>
      <input matInput placeholder="Tope Inscripción:"
        [value]="currentScheduleDate && currentScheduleDate.endDate ? (currentScheduleDate.endDate | date: 'mediumDate') : 'Sin tope'"
        type="text">
    </mat-form-field>
  </div>

</div>

<div class="row mb-5 blocked">

  <div class="col-md-4">
    <mat-form-field>
      <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
      <input matInput placeholder="Cuota Máxima:" [value]="(maxSavingContribution | number: '.2-2')" type="text">
    </mat-form-field>
  </div>

  <div class="col-md-4">

    <mat-form-field>
      <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
      <input matInput placeholder="Cuota Mínima:" [value]="(minContribution | number: '.2-2')" type="text">
    </mat-form-field>

  </div>

</div>

<app-header headerText="Aportaciones:" [small]="true"></app-header>

<div class="row" [ngClass]="{'mb-5': !logicService.shouldShowSavingExtras(currentEmployee)}" onpaste="return false">

  <div class="col-md-4">

    <mat-form-field>
      <span matPrefix>$&nbsp;</span>
      <input matInput placeholder="Cuota de Aportación:" [ngModel]="permanentSaving.contributionAmount | number: '1.'"
        (ngModelChange)="permanentSaving.contributionAmount=currencyInputChanged($event)" appOnlyNumber
        [allowDecimals]="true" type="text" [formControl]="formControlContributionAmount" required>
      <mat-error
        *ngIf="!formControlContributionAmount.hasError('max') && formControlContributionAmount.hasError('min')">
        El monto debe de ser mayor al mínimo</mat-error>
      <mat-error
        *ngIf="!formControlContributionAmount.hasError('min') && formControlContributionAmount.hasError('max')">
        El monto debe de ser menor al máximo </mat-error>
    </mat-form-field>

  </div>

  <div class="col-md-4">

    <mat-form-field>
      <input style="width:95%;" matInput placeholder="Reparto de Utilidades:"
        [(ngModel)]="permanentSaving.profitSharingPercentage" type="number" min="0"
        [formControl]="formControlProfitSharingPercentage"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57">
      <span matSufix>%</span>
      <mat-error *ngIf="formControlProfitSharingPercentage.invalid">Debe ingresar un porcentaje válido</mat-error>
    </mat-form-field>

  </div>

  <div class="col-md-4">

    <mat-form-field>
      <input style="width:95%;" matInput placeholder="Aguinaldo y Bono Anual Por Desempeño:"
        [(ngModel)]="permanentSaving.yearEndAndPerformanceBonusPercentage" type="number" min="0"
        [formControl]="formControlYearEndAndPerformanceBonusPercentage"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57">
      <span matSufix>%</span>
      <mat-error *ngIf="formControlYearEndAndPerformanceBonusPercentage.invalid">Debe ingresar un porcentaje válido
      </mat-error>
    </mat-form-field>

  </div>

</div>

<div class="row mb-5" *ngIf="logicService.shouldShowSavingExtras(currentEmployee)" onpaste="return false">

  <div class="col-md-4">

    <mat-form-field>
      <input style="width:95%;" matInput placeholder="Bono por Avance de Metas:"
        [(ngModel)]="permanentSaving.targetBonusPercentage" type="number" min="0"
        [formControl]="formControlTargetBonusPercentage"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57">
      <span matSufix>%</span>
      <mat-error *ngIf="formControlTargetBonusPercentage.invalid">Debe ingresar un porcentaje válido</mat-error>
    </mat-form-field>

  </div>

  <div class="col-md-4">

    <mat-form-field>
      <input style="width:95%;" matInput placeholder="Complemento Bono Anual Por Desempeño:"
        [(ngModel)]="permanentSaving.annualPerformanceBonusPercentage" type="number" min="0"
        [formControl]="formControlAnnualPerformanceBonusPercentage"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57">
      <mat-error *ngIf="formControlAnnualPerformanceBonusPercentage.invalid">Debe ingresar un porcentaje válido
      </mat-error>
      <span matSufix>%</span>
    </mat-form-field>

  </div>
  <div class="col-md-4" *ngIf="currentEmployee.isVeabBonusActive && currentEmployee.isVeabBonusActive === true">

    <mat-form-field>
      <input style="width:95%;" matInput placeholder="Bono VEAB:"
        [(ngModel)]="permanentSaving.veabBonus" type="number" min="0"
        [formControl]="formControlExtraordinaryPaymentsAdvanceBonus"
        onkeypress="return event.charCode >= 48 && event.charCode <= 57">
      <mat-error *ngIf="formControlExtraordinaryPaymentsAdvanceBonus.invalid">Debe ingresar un porcentaje válido
      </mat-error>
      <span matSufix>%</span>
    </mat-form-field>
  
  </div>

</div>


<div *ngFor="let b of permanentSaving.beneficiaries.values()">

  <app-header [headerText]="beneficiariesTitles[b.index]" [small]="true"></app-header>

  <div class="row">

    <div class="col-md-4">

      <mat-form-field>
        <input matInput placeholder="Nombre(s):" type="text" [formControl]="beneficiariesControls[b.index][0]">
        <mat-error *ngIf="!beneficiariesControls[b.index][0].valid">Debe de ingresar al menos un nombre</mat-error>
      </mat-form-field>

    </div>

    <div class="col-md-4">

      <mat-form-field>
        <input matInput placeholder="Apellido Paterno:" type="text" [formControl]="beneficiariesControls[b.index][1]">
        <mat-error *ngIf="!beneficiariesControls[b.index][1].valid">Debe de ingresar un apellido</mat-error>
      </mat-form-field>

    </div>

    <div class="col-md-4">

      <mat-form-field>
        <input matInput placeholder="Apellido Materno:" type="text" [formControl]="beneficiariesControls[b.index][2]">
        <mat-error *ngIf="!beneficiariesControls[b.index][2]">Debe de ingresar un apellido</mat-error>
      </mat-form-field>

    </div>

  </div>

  <div class="row mb-5">

    <div class="col-md-4">

      <mat-form-field>
        <input matInput placeholder="Parentesco:" type="text" [formControl]="beneficiariesControls[b.index][3]">
        <mat-error *ngIf="!beneficiariesControls[b.index][3].valid">Debe ingresar una relación</mat-error>
      </mat-form-field>

    </div>

    <div class="col-md-4">

      <mat-form-field>
        <input style="width:95%;" matInput placeholder="Porcentaje:" type="number" min="0"
          [formControl]="beneficiariesControls[b.index][4]"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57">
        <span matSufix>%</span>
        <mat-error *ngIf="!beneficiariesControls[b.index][4].valid">Debe ingresar un porcentaje válido</mat-error>
      </mat-form-field>

    </div>

    <div *ngIf="b.index > 0 && b.index === beneficiariesControls.length - 1" class="col-md-4 bottom-vertically">
      <button class="btn btn-block btn-primary" (click)="removeLastBeneficiary()">Eliminar Beneficiario</button>
    </div>

  </div>

</div>

<div *ngIf="this.beneficiariesControls.length < 10" class="my-4 row">

  <div class="col-md-4 offset-md-8">

    <button class="btn btn-block btn-primary" (click)="addBeneficiary()">Agregar otro Beneficiario</button>

  </div>

</div>

<div class="my-4 row">

  <div class="col-md-4 offset-md-4">
    <!-- TODO Mostrar confirmación antes de cancelar - REVISAR-->
    <button class="btn btn-outline-secondary btn-block" (click)="cancel(0, null)">Cancelar</button>
  </div>

  <div class="col-md-4">
    <!-- TODO Mostrar confirmación antes de guardar -->
    <button class="btn btn-block btn-primary" (click)="submitSubscription()">Registrarse</button>
  </div>

</div>
